module.exports = __webpack_public_path__ + "files/db49e10c67e843db4fb3dc41c707a88e.png";